<div [hidden]="!message" class="alert alert-{{type}} p-3 text-center" role="alert" #alertNotice>
	<div class="alert-text" [innerHTML]="message"></div>
</div>
